import { render } from "./PremiumSection.vue?vue&type=template&id=6f1f6f1f&scoped=true"
import script from "./PremiumSection.vue?vue&type=script&lang=js"
export * from "./PremiumSection.vue?vue&type=script&lang=js"

import "./PremiumSection.vue?vue&type=style&index=0&id=6f1f6f1f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f1f6f1f"]])

export default __exports__